module.exports = __webpack_public_path__ + "img/baseline-delete_forever-24px_grey.7c3f8e3a.svg";